import { selectMenusByType, selectMenuTypeId, selectVisibleMenus } from 'selectors/browse';

export default (dispatch, getState) =>
  ({ params, location }, replace) => {
    const state = getState();
    const menuTypeId = selectMenuTypeId(state);
    const serviceId = params.serviceId;

    // There are instances where the menuTypeId is not set, so we need to check for that
    // before we try to get the menus. If it's not set, we can do a simple check to
    // see if the available menus, filtered by active and to the service id provided,
    // is only one menu. If so, we can redirect to that menu.
    if (!menuTypeId) {
      const menus = selectVisibleMenus(state, serviceId);
      if (menus.size === 1) {
        const search = location.search || '';
        replace(`/service/${serviceId}/menu/${menus.first().get('id')}${search}`);
        return;
      }
    }

    // If we have a menuTypeId and a serviceId, we can get the menus and redirect
    const menus = selectMenusByType(state, menuTypeId, serviceId);
    if (menus.size === 1) {
      const search = location.search || '';
      replace(`/service/${serviceId}/menu/${menus.first().get('id')}${search}`);
    }
  };
